var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('button',{staticClass:"btn btn-icon btn-rounded btn-youtube",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleted()}}},[_c('i',{staticClass:"fa fa-trash-o"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }